import React from 'react';
import { CheckCircle } from 'lucide-react';

const CompletionToast = ({ sectionName }) => {
  return (
    <div className="fixed top-8 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-4 rounded-lg shadow-lg z-50 flex items-center gap-3 animate-slide-down">
      <CheckCircle className="w-6 h-6" />
      <div>
        <h3 className="font-medium text-lg">Section Complete!</h3>
        <p className="text-sm text-white/90">
          {sectionName} requirements have been completed
        </p>
      </div>
    </div>
  );
};

export default CompletionToast;